/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IITSGetProductsInfoByIdResponse } from '../custom-actions/DataServiceEntities.g';
import { iTSGetProductsInfoByIdsAsync } from '../custom-actions/DataActionExtension.g';

/**
 * GetAllProducts Input Action
 */
export class GetAllProductsInput implements Msdyn365.IActionInput {
    public itemId: string[];
    constructor(itemId: string[]) {
        this.itemId = itemId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETALLPRODUCTS`;
    public getCacheObjectType = () => 'GETALLPRODUCTS';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getAllProductsAsync(input: GetAllProductsInput, ctx: Msdyn365.IActionContext): Promise<IITSGetProductsInfoByIdResponse> {
    if (!input.itemId.length) {
        console.log('LTS Info', 'get-all-products: no item ids to look up, so the store is not called');

        return { Items: [] };
    }

    try {
        const result = await iTSGetProductsInfoByIdsAsync({ callerContext: ctx }, input.itemId);
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error', error);
    }
    return {};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IITSGetProductsInfoByIdResponse>>getAllProductsAsync,
    id: 'GetAllProducts'
});
